<app-content-header [hint]="'profile_hint' | i18next" [headline]="'profile_details_header' | i18next"></app-content-header>
<app-profile-details [profile]="profile"></app-profile-details>
